"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import { numberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationAllDrops } from "@/types/feed.types";
import { getNotificationVoteColor } from "../drop-reacted/NotificationDropReacted";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "../subcomponents/NotificationDrop";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationAllDrops(t0) {
  const $ = _c(43);
  const {
    notification,
    activeDrop,
    onReply,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  const drop = notification.related_drops?.[0];
  if (!drop) {
    return null;
  }
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== activeDrop || $[1] !== createQuoteClickHandler || $[2] !== createReplyClickHandler || $[3] !== drop || $[4] !== notification.additional_context.vote || $[5] !== notification.created_at || $[6] !== notification.related_identity || $[7] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    let t8;
    if ($[16] !== notification.additional_context.vote) {
      t8 = () => {
        if (typeof notification.additional_context.vote === "number") {
          const isReset = notification.additional_context.vote === 0;
          if (isReset) {
            return <span className="tw-text-iron-400">reset rating to 0</span>;
          }
          return <><span className="tw-text-iron-400">rated</span><span className={`${getNotificationVoteColor(notification.additional_context.vote)} tw-pl-1 tw-font-medium`}>{notification.additional_context.vote > 0 && "+"}{numberWithCommas(notification.additional_context.vote)}</span></>;
        }
        return <span className="tw-text-iron-400">posted</span>;
      };
      $[16] = notification.additional_context.vote;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    const getContent = t8;
    t6 = "tw-flex tw-w-full tw-flex-col tw-space-y-2";
    const t9 = notification.related_identity;
    let t10;
    if ($[18] !== notification.related_identity) {
      t10 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
      $[18] = notification.related_identity;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== getContent) {
      t11 = getContent();
      $[20] = getContent;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== notification.created_at) {
      t12 = <NotificationTimestamp createdAt={notification.created_at} />;
      $[22] = notification.created_at;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] !== t11 || $[25] !== t12) {
      t13 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t11}{" "}{t12}</span>;
      $[24] = t11;
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    if ($[27] !== notification.related_identity || $[28] !== t10 || $[29] !== t13) {
      t7 = <NotificationHeader author={t9} actions={t10}>{t13}</NotificationHeader>;
      $[27] = notification.related_identity;
      $[28] = t10;
      $[29] = t13;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    T0 = NotificationDrop;
    t1 = drop;
    t2 = activeDrop;
    t3 = onReply;
    t4 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t5 = createQuoteClickHandler(isDirectMessage);
    $[0] = activeDrop;
    $[1] = createQuoteClickHandler;
    $[2] = createReplyClickHandler;
    $[3] = drop;
    $[4] = notification.additional_context.vote;
    $[5] = notification.created_at;
    $[6] = notification.related_identity;
    $[7] = onReply;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    T0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[31] !== T0 || $[32] !== onDropContentClick || $[33] !== t1 || $[34] !== t2 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5) {
    t8 = <T0 drop={t1} activeDrop={t2} onReply={t3} onReplyClick={t4} onQuoteClick={t5} onDropContentClick={onDropContentClick} />;
    $[31] = T0;
    $[32] = onDropContentClick;
    $[33] = t1;
    $[34] = t2;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
}